import React from "react";
import { ServiceHero, SectionTitle, FeatureCard } from "@/components/Bits";
import { RequestForm } from "@/components/RequestForm";
import { useLang } from "@/context/LanguageContext";
import { Search, Home, Hammer, ClipboardCheck, KeyRound, ConciergeBell, FileBarChart, Building } from "lucide-react";

const ICONS = [Search, Home, Building, Hammer, ClipboardCheck, KeyRound, ConciergeBell, FileBarChart];

export default function Diaspora() {
  const { t } = useLang();
  const offers = t("svc.dia.offers").map((o, i) => ({ icon: ICONS[i], title: o.t, desc: o.d }));
  return (
    <div className="bg-ivory">
      <ServiceHero eyebrow={t("svc.dia.eyebrow")} title={t("svc.dia.title")} subtitle={t("svc.dia.subtitle")}
        image="https://images.unsplash.com/photo-1745725427804-4d94df0c5eb7?w=1920&q=85" />
      <section className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-16 py-20">
        <SectionTitle eyebrow={t("svc.dia.oEyebrow")} title={t("svc.dia.oTitle")} className="mb-12" />
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {offers.map((o) => <FeatureCard key={o.title} {...o} />)}
        </div>
      </section>
      <section className="max-w-3xl mx-auto px-4 sm:px-8 lg:px-16 pb-24">
        <SectionTitle center title={t("svc.dia.formTitle")} subtitle={t("svc.dia.formSub")} className="mb-8" />
        <RequestForm type="investissement" testid="diaspora-form" submitLabel={t("svc.dia.submit")}
          fields={[
            { name: "location", label: t("svc.dia.fCountry"), placeholder: t("svc.dia.fCountryPh") },
            { name: "subject", label: t("svc.dia.fProject"), placeholder: t("svc.dia.fProjectPh") },
            { name: "budget", label: t("svc.dia.fBudget"), placeholder: t("svc.dia.fBudgetPh") },
          ]} />
      </section>
    </div>
  );
}
